import { createAction, props } from '@ngrx/store';
import { Tree } from '@design/models/trees.model';

export namespace fromTreesActions {


  export const AddTree = createAction(
    '[Draw Area] add one Tree',
    props<{ trees: Tree }>()
  );

  export const AddManyTrees = createAction(
    '[Draw Area] add many trees',
    props<{ trees: Tree[] }>()
  );

  export const SelectTree = createAction(
    '[Draw Area] select Tree',
    props<{ trees: Tree | undefined }>()
  );

  export const CopyTree = createAction(
    '[Draw Area] copy Tree',
    props<{ trees: Tree }>()
  );

  export const TreeConfigurationChange = createAction(
    '[Tree Configuration] Update Tree configuration',
    props<{ trees: Tree }>()
  );

  export const UpdateTree = createAction(
    '[Draw Area] Update Tree bounds',
    props<{ tree: Tree }>()
  );
  export const DeleteTree = createAction(
    '[Tree Configuration] Delete Tree Success',
    props<{ tree: Tree }>()
  );
  export const SaveTrees = createAction(
    '[Trees] Save trees data to quote'
  );
}
